import { Link, Navigate } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/auth/AuthProvider";

// Branded splash / landing page at the index route. Mobile-first, centered
// hero. The "Broker sign-in" CTA links to /login, where the broker authenticates
// against the PMS Cognito BFF (BRK-S007). An already-signed-in broker is sent
// straight to the portal instead of being shown a sign-in CTA; while the
// on-mount silent refresh is still resolving we hold the CTA back so it never
// flashes at someone who turns out to be authenticated.
export function SplashPage() {
  const { status } = useAuth();

  if (status === "authenticated") {
    return <Navigate to="/portal" replace />;
  }

  return (
    <section className="flex flex-col items-center gap-6 py-8 text-center sm:py-16">
      <Brand size="lg" />

      <h1 className="max-w-2xl text-3xl font-bold tracking-tight sm:text-4xl">
        Submissions and policy tracking for our brokers
      </h1>

      <p className="max-w-prose text-base text-white/70 sm:text-lg">
        Enter new general-liability submissions and follow each policy from
        quote to bind — all in one place, on any device.
      </p>

      {status === "anonymous" && (
        <div className="flex w-full flex-col items-center gap-3">
          <Link
            to="/login"
            className="w-full max-w-xs rounded-md bg-brk-accent px-5 py-3 font-medium text-white no-underline transition-colors hover:bg-brk-accent-strong sm:w-auto"
          >
            Broker sign-in
          </Link>
        </div>
      )}
    </section>
  );
}
